"use client";

import { Button } from "@/components/ui/button";
import { Card, CardContent, CardDescription, CardFooter, CardHeader, CardTitle } from "@/components/ui/card";
import { Link } from "@/components/common/Link";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { Flame, Shield, Droplet, Wrench } from "lucide-react";
export default function ServiceListings() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    once: true,
    threshold: 0.2
  });
  const services = [{
    id: 1,
    icon: Flame,
    title: "Fire Extinguisher Inspections",
    description: "Comprehensive inspection, recharging, and replacement services for all types of fire extinguishers.",
    hasButton: true
  }, {
    id: 2,
    icon: Shield,
    title: "Ansul Hood Systems",
    description: "Professional installation and maintenance of commercial kitchen hood suppression systems.",
    hasButton: true
  }, {
    id: 3,
    icon: Droplet,
    title: "Sprinkler Testing",
    description: "Thorough sprinkler system inspections, testing, and certifications for residential and commercial properties.",
    hasButton: true
  }, {
    id: 4,
    icon: Wrench,
    title: "Fire Safety Training",
    description: "We offer on‑site fire safety and extinguisher training for your entire team. Prepared teams respond faster and safer.",
    hasButton: true
  }];
  return <section className="bg-background py-16 px-4">
      <div ref={ref} className={`container mx-auto transition-all duration-300 ease-[cubic-bezier(0.4,0,0.2,1)] ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-2.5"}`}>
        <div className="grid grid-cols-1 gap-6 md:grid-cols-2 lg:grid-cols-4">
          {services.map((service, i) => {
          const IconComponent = service.icon;
          return <Card key={service.id} data-index={i} className={`border-2 border-primary bg-light-background shadow-soft transition-all duration-300 ease-[cubic-bezier(0.22,1,0.36,1)] hover:-translate-y-1 hover:shadow-[0_0_20px_rgba(255,127,0,0.3)]`}>
                <CardHeader className="items-center text-center">
                  <div className="mb-4 flex size-16 items-center justify-center rounded-full bg-primary/10">
                    <IconComponent className="size-8 text-primary" />
                  </div>
                  <CardTitle className="text-lg font-bold text-foreground">
                    {service.title}
                  </CardTitle>
                </CardHeader>
                <CardContent className="text-center">
                  <CardDescription className="text-sm text-muted-foreground">
                    {service.description}
                  </CardDescription>
                </CardContent>
                {service.hasButton && <CardFooter className="justify-center">
                    <Button asChild variant="outline" className="border-primary text-primary transition-all duration-150 hover:scale-[1.02] hover:bg-primary hover:text-foreground-primary">
                      <Link to="/ServicesPage">Learn More</Link>
                    </Button>
                  </CardFooter>}
              </Card>;
        })}
        </div>
      </div>
    </section>;
}